// extracted by mini-css-extract-plugin
export default {"formHolder":"email-form_formHolder__ThZ22"};